import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { getUser } from "../Store/Reducers/UserReducer";

// ── Welcome ──────────────────────────────────────────────────────────────────
//
// The first thing a patient sees after signing in. It shows NOTHING about them
// but their first name: no tiles, no menu, no results. That is the point, so
// that nobody reading over their shoulder learns anything until they choose to
// go on. It covers the whole window (the menu and the name in the top bar
// included) and a single clear button goes to the Overview.

const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
};

export default function Welcome() {
  const navigate = useNavigate();
  const user = useSelector(getUser);
  const button = useRef(null);

  const first =
    user?.firstName ||
    String(localStorage.getItem("UserName") || "").trim().split(/\s+/)[0] ||
    "";

  useEffect(() => { button.current && button.current.focus(); }, []);

  return (
    <main className="ox-welcome" aria-labelledby="ox-welcome-h">
      <div className="ox-welcome__inner">
        <div className="ox-welcome__logo" aria-label="OX assisted reproduction">
          <span className="ox-welcome__ox">OX<i /></span>
          <span className="ox-welcome__sub">assisted<br />reproduction</span>
        </div>

        <h1 id="ox-welcome-h" className="ox-welcome__hello">
          {greeting()}, <strong>{first || "welcome"}</strong>
        </h1>

        <p className="ox-welcome__tag">Connecting patients &bull; clinicians &bull; data</p>
        <hr className="ox-welcome__rule" />
        <p className="ox-welcome__line">Working together, we can build a better future.</p>

        <button ref={button} type="button" className="ox-welcome__go" onClick={() => navigate("/Overview")}>
          Click here to continue
          <i className="fa-solid fa-arrow-right" aria-hidden="true" />
        </button>
        <p className="ox-welcome__note">
          <i className="fa-solid fa-lock" aria-hidden="true" /> Your details stay hidden until you continue.
        </p>
      </div>
    </main>
  );
}
